import script from "./TelegramActivation.vue?vue&type=script&setup=true&lang=js"
export * from "./TelegramActivation.vue?vue&type=script&setup=true&lang=js"

import "./TelegramActivation.vue?vue&type=style&index=0&id=21871c98&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21871c98"]])

export default __exports__